// RecieverContext.js
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { redirect } from 'react-router';
import PropTypes from 'prop-types'; // @mui
import { apiService } from 'src/utils/apiServices';
import { PHYSICAL_API, emptyToNull, withoutEmptyValues } from 'src/utils/physical-api';
import { toast } from 'react-toastify';

const RecieverContext = createContext();
const RecieverActionsContext = createContext();

export const RecieverProvider = ({ children }) => {
  const [Recievers, setRecievers] = useState([]);
  const [custumerRecordDetails, setRecieverRecordDetails] = useState({});

  const createReciever = async (newReciever, addressData) => {
    try {
      const response = await apiService.post(PHYSICAL_API.receivers, withoutEmptyValues(newReciever), {
        headers: {
          timeout: 20000,
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      // eslint-disable-next-line
      const data = response.data;
      setRecievers((prevRecievers) => [...prevRecievers, data]);
      toast.success('Receiver created!');

      const dataAddressResponse = await apiService.post(
        PHYSICAL_API.addresses,
        { ...withoutEmptyValues(addressData), reciever_id: data.id },
        {
          headers: {
            timeout: 20000,
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

      // Log the full response and the data
      console.log('Full Address Response:', dataAddressResponse);
      console.log('Created Address Data:', dataAddressResponse.data);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'something went wrong');
      console.error('Error creating Receiver:', error);
    }
  };

  const deleteReciever = async (RecieverId) => {
    try {
      await apiService.put(
        '/Recievers/update/soft',
        { ids: RecieverId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      setRecievers((prevRecievers) =>
        prevRecievers.filter((Reciever) => !RecieverId.includes(Reciever.id))
      );
      toast.success('Receiver deleted!');
    } catch (error) {
      toast.error('Error deleting Receiver');
      console.error('Error deleting Receiver:', error);
    }
  };

  const updateReciever = async (RecieverId, updatedReciever) => {
    try {
      // Simulate API call to update Reciever
      const response = await apiService.patch(`${PHYSICAL_API.receivers}/${RecieverId}`, emptyToNull(updatedReciever), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.data;
      setRecievers((prevRecievers) =>
        prevRecievers.map((Reciever) =>
          Reciever.id === RecieverId ? { ...Reciever, ...data } : Reciever
        )
      );
      toast.success('Receiver updated!');
    } catch (error) {
      toast.error('Error updating Receiver');
      console.error('Error updating Receiver:', error);
    }
  };

  const updatePersonalAddress = async (addressId, updatedAddress, filters) => {
    try {
      // Simulate API call to update Reciever
      const response = await apiService.patch(`${PHYSICAL_API.addresses}/${addressId}`, emptyToNull(updatedAddress), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      // eslint-disable-next-line
      const data = await response.data;
      getRecievers(filters);
      toast.success('address updated!');
    } catch (error) {
      toast.error('Error updating address');
      console.error('Error updating address:', error);
    }
  };

  const getRecievers = async (filters = {}) => {
    try {
      const query = new URLSearchParams(withoutEmptyValues(filters)).toString();
      const response = await apiService.get(`${PHYSICAL_API.receivers}?${query}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.data.data;
      setRecievers(data);
      setRecieverRecordDetails({
        page: response.data.page,
        take: response.data.take,
        total: response.data.total,
        totalPages: Math.ceil(+response.data.total / +response.data.take),
      });
    } catch (error) {
      console.error('Error fetching Recievers:', error);
      if (error.response.status === 401) {
        localStorage.removeItem('token');
        redirect('/');
      }
    }
  };

  const getRecieverById = async (RecieverId) => {
    try {
      const response = await apiService.get(`${PHYSICAL_API.receivers}/${RecieverId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Receiver by ID:', error);
      throw error;
    }
  };

  const deleteCard = async (RecieverId, cardId) => {
    try {
      const response = await apiService.post(
        `/Recievers/deleteCard`,
        { id: RecieverId, cardId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      toast.success('Card deleted successfully');
      return response.data;
    } catch (error) {
      toast.error(error.response.data.error);
      throw error;
    }
  };

  const getRecieverCards = async (id) => {
    try {
      // Simulate API call to get Reciever by ID
      const response = await apiService.get(`/Recievers/findCards/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Receiver by ID:', error);
      throw error;
    }
  };
  useEffect(() => {
    // getRecievers();
  }, []);

  const createRecieverCallback = useCallback(createReciever, []);
  const updatePersonalAddressCallback = useCallback(updatePersonalAddress, []);
  const deleteRecieverCallback = useCallback(deleteReciever, []);
  const updateRecieverCallback = useCallback(updateReciever, [updateReciever]);
  const getRecieversCallback = useCallback(getRecievers, []);
  const getRecieverByIdCallback = useCallback(getRecieverById, []);
  const getRecieverCardsCallback = useCallback(getRecieverCards, []);
  const deleteCardCallback = useCallback(deleteCard, []);
  const RecieverActionsValue = useMemo(
    () => ({
      createReciever: createRecieverCallback,
      deleteReciever: deleteRecieverCallback,
      updateReciever: updateRecieverCallback,
      getRecievers: getRecieversCallback,
      getRecieverById: getRecieverByIdCallback,
      getRecieverCards: getRecieverCardsCallback,
      deleteCard: deleteCardCallback,
      updatePersonalAddress: updatePersonalAddressCallback,
    }),
    [
      createRecieverCallback,
      deleteRecieverCallback,
      updateRecieverCallback,
      getRecieversCallback,
      getRecieverByIdCallback,
      getRecieverCardsCallback,
      deleteCardCallback,
      updatePersonalAddressCallback,
    ]
  );

  const RecieversValue = useMemo(
    () => ({
      Recievers,
      custumerRecordDetails,
    }),
    [Recievers, custumerRecordDetails]
  );

  return (
    <RecieverContext.Provider value={RecieversValue}>
      <RecieverActionsContext.Provider value={RecieverActionsValue}>
        {children}
      </RecieverActionsContext.Provider>
    </RecieverContext.Provider>
  );
};

export const useRecieverData = () => useContext(RecieverContext);
export const useRecieverActions = () => useContext(RecieverActionsContext);

RecieverProvider.propTypes = {
  children: PropTypes.element,
};
